import { defineComponent as _defineComponent } from 'vue'
import { ComplianceStatus, OnboardingStatusLabel } from 'ah-api-gateways';
import StatusPill from 'ah-common-lib/src/common/components/StatusPill.vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingStatusPill',
  props: {
    status: null
  },
  setup(__props: any) {



const statusColors = computed<Record<ComplianceStatus, string>>(() => {
  return {
    [ComplianceStatus.APPROVED]: 'success',
    [ComplianceStatus.DOCUMENTS_REQUIRED]: 'orange',
    [ComplianceStatus.TERMS_AND_CONDITIONS]: 'orange',
    [ComplianceStatus.SUBMITTED]: 'warning',
    [ComplianceStatus.PENDING]: 'blue',
    [ComplianceStatus.REJECTED]: 'danger',
    [ComplianceStatus.UPDATED_TERMS_AND_CONDITIONS]: 'primary',
    [ComplianceStatus.UNKNOWN]: 'grey',
    [ComplianceStatus.DEACTIVATED]: 'grey',
    [ComplianceStatus.SUSPENDED]: 'grey',
    [ComplianceStatus.SUSPENDED_UPDATED_TCS_NOT_ACCEPTED]: 'red',
  };
});

const defaultStatusLabels = computed<Record<ComplianceStatus, string>>(() => {
  return {
    [ComplianceStatus.APPROVED]: 'Approved',
    [ComplianceStatus.DOCUMENTS_REQUIRED]: 'Incomplete',
    [ComplianceStatus.PENDING]: 'Pending',
    [ComplianceStatus.REJECTED]: 'Rejected',
    [ComplianceStatus.UPDATED_TERMS_AND_CONDITIONS]: 'T&Cs Updated',
    [ComplianceStatus.SUBMITTED]: 'Submitted',
    [ComplianceStatus.TERMS_AND_CONDITIONS]: 'Incomplete',
    [ComplianceStatus.UNKNOWN]: 'Unknown',
    [ComplianceStatus.DEACTIVATED]: 'Deactivated',
    [ComplianceStatus.SUSPENDED]: 'Suspended',
    [ComplianceStatus.SUSPENDED_UPDATED_TCS_NOT_ACCEPTED]: 'Suspended - T&C’s outstanding',
  };
});

return { __sfc: true,statusColors, defaultStatusLabels, ComplianceStatus, StatusPill }
}

})